module.exports = __webpack_public_path__ + "img/application_message.28469689.svg";